import { faBoxes } from '@fortawesome/pro-light-svg-icons';
import { FunctionComponent, useMemo } from 'react';
import Filter from 'components/Bookings2/List/Filter/Filter';
import { useMasterData } from 'hooks';

interface StockStatusFilterProps {
    selected: Array<string>;
    singleSelection?: boolean;
    className?: string;
    onChangeSelection?: (selectedStatusIds: Array<string>) => void;
}

export const StockStatusFilter: FunctionComponent<StockStatusFilterProps> = props => {
    const masterData = useMasterData();

    const statuses = useMemo(
        () =>
            [...(masterData.inventory?.statuses ?? [])].sort((status, otherStatus) =>
                status.name.localeCompare(otherStatus.name)
            ),
        [masterData.inventory?.statuses]
    );

    return statuses.length > 0 ? (
        <Filter
            allLabel="All Statuses"
            quantityLabel="statuses"
            icon={faBoxes}
            options={statuses}
            selectedOptions={statuses.filter(status => props.selected.includes(status.id))}
            singleSelection={props.singleSelection}
            hideSearch
            onChangeSelection={options => props.onChangeSelection?.(options.map(option => option.id))}
            className={props.className}
        />
    ) : null;
};

export default StockStatusFilter;
